<template>
        <div id="Contatti">
            <div  :class="['sede-container',sede.attributes.title]" v-for="(sede, index) in sedi.slice(0,1)" :key="sede.id">
                <div v-if="index <= 0" >
                    <!-- SEDE DI TRIESTE -->
                    <div class="row">
                        <div class="col-md-12 col-lg-6">
                            <p>{{sede.attributes.field_indirizzo_via}}</p>
                            <p>{{sede.attributes.field_indirizzo_cap}}</p>
                            <p>Tel: {{sede.attributes.field_telefono}}</p>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <ul>
                                <li>E-mail:</li>
                                <li><a style="color:#F04533"  :href="`mailto:${sede.attributes.field_e_mail}`">{{sede.attributes.field_e_mail}}</a></li>
                            </ul>
                            <ul>
                                <li>{{labelEmail}}:</li>
                                <li><a style="color:#F04533"  :href="`mailto:${sede.attributes.field_e_mail_certificata}`">{{sede.attributes.field_e_mail_certificata}}</a></li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    <!-- SEDE DI TREVISO E ROMA -->
                    <div v-if="index >= 1" >
                        <h1>Sede di {{sede.attributes.title}}</h1>
                        <div>
                            <p><span>{{sede.attributes.field_indirizzo_cap}}</span> - <span>{{sede.attributes.field_indirizzo_via}}</span></p>
                            <p><span>{{sede.attributes.field_telefono}}</span> / <span>{{sede.attributes.field_fax}}</span></p>
                            <p><span><a href="">{{sede.attributes.field_e_mail}}</a></span> - <span><a href="">manca il website</a></span></p>
                        </div>
                    </div>
                </div>
                <div>
                    <a class="btn-custom" target="_blank" href="https://www.google.com/maps/place/TUDOR+NICOLAOU+STUDIO+LEGALE+ASSOCIATO/@45.649952,13.7715821,15z/data=!4m2!3m1!1s0x0:0xae0f4e488f485808?sa=X&ved=2ahUKEwiu4PLzwP3uAhU5A2MBHVTLBTIQ_BIwCnoECBsQBQ">{{labelMap}}</a>
                </div>
        </div>
</template>
<script>

export default {
  name: 'sedi',

  props: {
      dataSedi: {
          type: String
      }
  },
  data:()=>{
        return {
            sedi:[]
        }
  },
computed:{
    labelEmail(){
        let label;
        if(this.$route.params.lang == "it"){
            label = "E-mail certificata"
        } else {
            label = "Certified e-mail"
        }
        return label
    },
    labelMap(){
        let label;
        if(this.$route.params.lang == "it"){
            label = "Come raggiungerci"
        } else {
            label = "How to reach us"
        }
        return label
    },
},
    mounted(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/sedi", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.sedi = json.data
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.btn-custom {
    color: #F04533;
    font-weight: 600;
}
    h1,p {
        color:#fff;
    }
    .sede-container{
        position: relative;
        margin-bottom:3.5rem;
        &:before{
            display: block;
            position: absolute;
            font-size: 0.6875rem;
            letter-spacing: 5px;
            transform: translate3d(0px,0px,0px) rotate(-90deg);
            text-transform: uppercase;
            top: 80px;
            left: -150px;
        }
        li{
                font-size: 0.875rem;
                color: #14182E;
                line-height: 1rem;
            }
            a{
                color: #F04533;
            }
    }

    .sede-container.Treviso{
        &:before{
            content: "Sedi secondarie";
    }
}

.sede-container.Trieste {
margin-bottom:1rem;

}

@media (max-width: 768px){
    .contatti.section .sede-container {
         h1 {
            font-size: 1.5rem;
            margin-bottom: 0.5rem;
        }
        ul {
            padding: 0;
        }
    }
    .sede-container.Trieste {
        margin-bottom: 2rem;
    }
}







</style>
